import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
// import LinearProgress from "@mui/material/LinearProgress";
import { rankingSorter, CustomPagination, CustomNoRowsOverlay } from "../../../SecondaryFunctions";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import { Button, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import { BsSearch } from "react-icons/bs";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
	// createSearchParams,
	useNavigate,
	useSearchParams,
	useLocation,
} from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormGroup from "@mui/material/FormGroup";
import CircularProgress from "@mui/material/CircularProgress";
import { SearchablePDF } from "../../Report Download/SearchablePDF";

const columns = [
	{
		field: "course",
		headerName: "Course",
		// width: 400,
		flex: 0.3,
		align: "center",
		headerAlign: "center",
		renderCell: (params) => (
			<div className="flex items-center justify-center h-full">{params.value}</div>
		),
	},
	{
		field: "description",
		headerName: "Description",
		// width: 490,
		flex: 0.25,
		align: "center",
		headerAlign: "center",
		renderCell: (params) => (
			<div className="flex items-center justify-center h-full">{params.value}</div>
		),
	},
	{
		field: "name",
		headerName: "Name",
		// width: 250,
		flex: 0.25,
		align: "center",
		headerAlign: "center",
		renderCell: (params) => (
			<div className="flex items-center justify-center h-full">{params.value}</div>
		),
	},
	{
		field: "term",
		headerName: "Term",
		// width: 150,
		flex: 0.2,
		align: "center",
		headerAlign: "center",
		renderCell: (params) => (
			<div className="flex items-center justify-center h-full">{params.value}</div>
		),
	},
];

export default function SearchSpotResults() {
	const [loaded, setLoaded] = useState(false);
	const [loadingBar, setLoadingBar] = useState(true);
	const [apiFetched, setApiFetched] = useState(false);
	let [courseData, setCourseData] = useState([]);
	let [filteredCourseData, setFilteredCourseData] = useState([]);
	const [searchCategory, setSearchCategory] = useState("");
	let [filters, setFilters] = useState({
		faculty: [],
		department: [],
		acyear: [],
		term: [],
	});
	const [searchValue, setSearchValue] = useState("");
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const [selectedItems, setSelectedItems] = useState([]);
	const [selectedIDs, setSelectedIDs] = useState([]);
	const [selectedCourses, setSelectedCourses] = useState([]);
	const navigate = useNavigate();
	const [openWindow, setOpenWindow] = useState(false); // Control the visibility of a dialog window
	const [checked, setChecked] = useState([true, true, true, true]);
	const [pdfLoading, setPdfLoading] = useState(false);
	const [pdfGrouping, setPdfGrouping] = useState(1);

	const handleCheck0 = (event) => {
		setChecked([event.target.checked, checked[1], checked[2], checked[3]]);
	};

	const handleCheck1 = (event) => {
		setChecked([checked[0], event.target.checked, checked[2], checked[3]]);
	};

	const handleCheck2 = (event) => {
		setChecked([checked[0], checked[1], event.target.checked, checked[3]]);
	};

	const handleCheck3 = (event) => {
		setChecked([checked[0], checked[1], checked[2], event.target.checked]);
	};

	const handlePDFgrouping = (event) => {
		setPdfGrouping(event.target.value);
	};

	// Function to open the dialog window for generating reports
	const handleClickOpen = () => {
		if (selectedCourses.length > 0) {
			setOpenWindow(true);
		}
	};

	// Function to close the dialog window
	const handleClose = () => {
		setOpenWindow(false);
	};

	// If the the enter key is pressed
	const handleKeypress = (e) => {
		if (e.key === "Enter") {
			// use key instead of deprecated keyCode
			searchBar();
		}
	};

	const ChangeSearchCategory = (event) => {
		setSearchCategory(event.target.value);
	};

	/**
	 * This function performs filtering on the 'courseData' array based on the 'searchValue' and 'searchCategory'.
	 */
	function searchBar() {
		if (searchCategory !== "") {
			let temp = filteredCourseData;
			if (searchCategory === "Course Title") {
				temp = temp.filter((item) => item.course.includes(searchValue));
			}
			if (searchCategory === "Instructor Name") {
				temp = temp.filter((item) => item.name.toUpperCase().includes(searchValue));
			}
			setFilteredCourseData(temp);
		}
	}

	// Function that is used to clear the fitlered data and put back the original data
	function handleClear() {
		let clearedSeach = "";
		setSearchValue(clearedSeach);
		applyFilters(clearedSeach);
	}

	function updateFilters(fgroup, value, checked) {
		let updatedFilters = filters;

		if (checked) {
			if (!updatedFilters[fgroup].includes(value)) {
				updatedFilters[fgroup].push(value);
			}
		} else {
			updatedFilters[fgroup] = updatedFilters[fgroup].filter((item) => item !== value);
		}

		setFilters(updatedFilters);
		applyFilters(searchValue);
	}

	function applyFilters(searchFilter) {
		const filterCategories = ["acyear", "term"];
		let courseData_copy = courseData;
		let filteredData = [];
		if (searchCategory === "Course Title") {
			courseData_copy = courseData_copy.filter((item) => item.course.includes(searchFilter));
		}
		if (searchCategory === "Instructor Name") {
			courseData_copy = courseData_copy.filter((item) =>
				item.name.toUpperCase().includes(searchFilter),
			);
		}
		filterCategories.forEach((category) => {
			if (filters[category].length !== 0) {
				let temp = courseData_copy.filter((item) => filters[category].includes(item[category]));

				if (filteredData.length === 0) {
					filteredData = temp;
				} else {
					filteredData = filteredData.filter((value) => temp.includes(value));
				}
			} else {
				if (filteredData.length === 0) {
					filteredData = courseData_copy;
				} else {
					filteredData = filteredData.filter((value) => courseData_copy.includes(value));
				}
			}
		});

		if (filteredData.length !== 0) {
			filteredData.sort(rankingSorter("termNum", "ctitle"));
			setFilteredCourseData(filteredData);
		}
	}

	useEffect(() => {
		let url = process.env.REACT_APP_BACKEND_HOST;
		if (sessionStorage.getItem("access").includes("ADMIN")) {
			url = url.concat("/spot/admin_search_spot_results/");
		} else if (sessionStorage.getItem("access").includes("STD")) {
			url = url.concat("/spot/std_search_spot_results/");
		} else {
			url = url.concat("/spot/search_spot_results/");
		}

		async function fetch_results(entered) {
			if (!entered || entered.length === 0) {
				setApiFetched(true);
				return [];
			}
			const response = await fetch(url.concat(entered, "/"), {
				headers: { Authorization: `Token ${sessionStorage.token}` },
			});
			const json = await response.json();

			// Process the JSON data and create an array of objects with specific properties
			let apiData = [];
			let idValue = 0;
			for (let i = 0; i < json.length; i++) {
				let entry = {
					id: idValue,
					acyear: json[i].ACYEAR.trim(),
					term: json[i].DESC_TERM.trim(),
					termNum: json[i].TERM,
					faculty: json[i].FNAME.trim(),
					department: json[i].DISPLAY_NAME.trim(),
					reqnum: json[i].REQNUM,
					clsnum: json[i].CLSNUM,
					classid: json[i].CLASSID,
					course: json[i].CTITLE.trim(),
					description: json[i].DESCRIPTION.trim(),
					ctype: json[i].CTYPE.trim(),
					empid: json[i].EMPID,
					name: json[i].NAME.trim(),
				};
				apiData.push(entry);
				idValue++;
			}

			setApiFetched(true);
			return apiData;
		}

		// NEW: prefer state, then query params, then sessionStorage; persist derived values
		function deriveEnteredFromInputs() {
			const state =
				(location.state && typeof location.state === "object" ? location.state : null) || null;

			const course =
				(state && state.course) ||
				searchParams.get("course") ||
				sessionStorage.getItem("sr_course") ||
				"";

			const empid =
				(state && state.empid) ||
				searchParams.get("empid") ||
				sessionStorage.getItem("sr_empid") ||
				"";

			const inst =
				(state && state.inst) ||
				searchParams.get("inst") ||
				sessionStorage.getItem("sr_inst") ||
				"";

			// Persist for hard refreshes
			if (course) sessionStorage.setItem("sr_course", course);
			if (empid) sessionStorage.setItem("sr_empid", empid);
			if (inst) sessionStorage.setItem("sr_inst", inst);

			// Choose the first non-"?" meaningful value (course > empid > inst)
			if (course && course !== "?") return course;
			if (empid && empid !== "?") return empid;
			if (inst && inst !== "?") return inst;
			return "";
		}

		// Fetch data if not loaded
		if (!loaded) {
			const entered = deriveEnteredFromInputs();

			let apiData = [fetch_results(entered)];
			if (apiFetched) {
				Promise.all(apiData).then((values) => {
					let data = values[0];
					data.sort(rankingSorter("termNum", "ctitle"));
					setCourseData(data);
					setFilteredCourseData(data);
				});
				setLoaded(true);
			}
		}

		// Show loading bar if loaded and still loading
		if (loaded && loadingBar) {
			setTimeout(() => {
				setLoadingBar(false);
			}, 3000);
		}
	}, [
		loaded,
		courseData,
		filteredCourseData,
		loadingBar,
		apiFetched,
		searchParams,
		location.state, // ensure effect re-evaluates if state navigation occurs
	]);

	// function that iterates over selected rows and stores reqnum and clsnum from row data
	function getItems(items) {
		let selected_items = [];
		let selected_ids = [];
		let selected_courses = [];
		for (let i = 0; i < items.length; i++) {
			let entry = filteredCourseData.filter((x) => x.id === items[i]);
			selected_items.push({
				id: entry[0].reqnum.toString().concat("_", entry[0].clsnum.toString()),
				term: entry[0].term,
				course: entry[0].course,
				empid: entry[0].empid,
				name: entry[0].name,
			});
			selected_ids.push(entry[0].reqnum.toString().concat("_", entry[0].clsnum.toString()));
			selected_courses.push(entry[0].course);
		}
		setSelectedItems(selected_items);
		setSelectedIDs(selected_ids);
		setSelectedCourses(selected_courses);
	}

	const handleSelectionModelChange = (newSelection) => {
		let items = [];

		if (Array.isArray(newSelection)) {
			items = newSelection;
		} else if (newSelection?.type === "exclude") {
			if (newSelection?.ids.size > 0) {
				const excludedIds = new Set(newSelection.ids);
				items = new Set(
					filteredCourseData.filter((row) => !excludedIds.has(row.id)).map((row) => row.id),
				);
			} else {
				items = new Set(filteredCourseData.map((row) => row.id));
			}
		} else if (newSelection?.type === "include" && newSelection?.ids) {
			items = newSelection.ids;
		} else {
			items = [];
		}

		//convert idArray to an array of numbers FROM set
		if (items instanceof Set) {
			items = Array.from(items).map((id) => Number(id));
		}

		getItems(items);
	};

	function generateReport() {
		navigate("/reporting/Report-View", {
			state: {
				reqID: selectedIDs,
				cname: selectedCourses,
			},
		});
	}

	async function PrintReport() {
		function allFalse(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] === true) {
					return false;
				}
			}
			return true;
		}

		if (!allFalse(checked)) {
			if (pdfGrouping === 1) {
				setPdfLoading(true);
				await SearchablePDF(selectedIDs, checked, "SPOT_Report.pdf");
				setPdfLoading(false);
			} else if (pdfGrouping === 2) {
				setPdfLoading(true);
				for (let item of selectedItems) {
					let selected_data = [item.id];
					let filename = item.term.concat(" - ", item.course, " - ", item.name, ".pdf");
					await SearchablePDF(selected_data, checked, filename);
				}
				setPdfLoading(false);
			} else if (pdfGrouping === 3) {
				let courses = [...new Set(Object.values(selectedItems).map((item) => item.course))];
				setPdfLoading(true);
				for (let course of courses) {
					let selected_data = selectedItems
						.filter((item) => item.course === course)
						.map((item) => item.id);
					let filename = course.concat(".pdf");
					await SearchablePDF(selected_data, checked, filename);
				}
				setPdfLoading(false);
			} else if (pdfGrouping === 4) {
				let empids = [...new Set(Object.values(selectedItems).map((item) => item.empid))];
				setPdfLoading(true);
				for (let empid of empids) {
					let selected_data = selectedItems
						.filter((item) => item.empid === empid)
						.map((item) => item.id);
					let filename = selectedItems.find((item) => item.empid === empid).name.concat(".pdf");
					await SearchablePDF(selected_data, checked, filename);
				}
				setPdfLoading(false);
			}
			// handleClickOpen();
		}
	}

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				height: "100vh",
				maxHeight: `calc(100vh - calc(13rem + 8px))`,
				backgroundColor: "#F5F5F5"
			}}
		>
			<Box
				sx={{
					width: "21%",
					maxWidth: 400,
					// height:'auto',
					// borderRight: "2px solid rgba(0, 0, 0, .5)",
					// borderColor: "rgba(0, 0, 0, 0.2)",
					paddingLeft: "10px",
					paddingRight: "10px",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						marginTop: "10px",
						marginBottom: "10px",
					}}
				>
					<FormControl size="small" sx={{ width: "378px" }}>
						<InputLabel id="demo-simple-select-label">Search Category</InputLabel>
						<Select value={searchCategory} label="Search Category" onChange={ChangeSearchCategory} sx={{backgroundColor:'#fff'}}>
							<MenuItem value={"Course Title"}>Course Title</MenuItem>
							<MenuItem value={"Instructor Name"}>Instructor Name</MenuItem>
						</Select>
					</FormControl>
				</Box>

				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						marginBottom: "10px",
					}}
				>
					<TextField
						label={searchCategory}
						size="small"
						value={searchValue}
						onChange={(e) => {
							setSearchValue(e.target.value.toUpperCase());
						}}
						onKeyUp={handleKeypress}
						sx={{ width: "322px" , backgroundColor:'#fff'}}
						InputProps={{
							endAdornment: (
								<IconButton onClick={handleClear}>
									{searchValue.length > 0 ? <ClearIcon /> : ""}
								</IconButton>
							),
						}}
					/>

					<Button
						variant="contained"
						style={{
							backgroundColor: "#275d38",
							fontSize: "1.2rem",
							marginLeft: "2px",
						}}
						onClick={searchBar}
					>
						<BsSearch />
					</Button>
				</Box>

				<Accordion disableGutters>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography>Academic Year</Typography>
					</AccordionSummary>
					<AccordionDetails>
						{[...new Set(courseData.map((item) => item.acyear))].map((acyear, index) => (
							<FormControlLabel
								key={index}
								control={
									<Checkbox
										onChange={(e) => {
											updateFilters("acyear", e.target.value, e.target.checked);
										}}
									/>
								}
								value={acyear}
								label={acyear}
							/>
						))}
					</AccordionDetails>
				</Accordion>

				<Accordion disableGutters defaultExpanded>
					<AccordionSummary expandIcon={<ExpandMoreIcon />} s>
						<Typography>Term</Typography>
					</AccordionSummary>
					<AccordionDetails>
						{[...new Set(courseData.map((item) => item.term))].map((term, index) => (
							<FormControlLabel
								key={index}
								control={
									<Checkbox
										onChange={(e) => {
											updateFilters("term", e.target.value, e.target.checked);
										}}
									/>
								}
								value={term}
								label={term}
							/>
						))}
					</AccordionDetails>
				</Accordion>
			</Box>
			<div className="p-2 w-[79%] flex flex-col h-[75dvh]">
				<DataGrid
					getRowHeight={() => "auto"}
					disableColumnFilter
					disableColumnSelector
					disableColumnMenu
					style={{ textAlign: "center" }}
					columns={columns}
					rows={filteredCourseData}
					pageSize={100}
					rowsPerPageOptions={[100]}
					checkboxSelection
					onRowSelectionModelChange={handleSelectionModelChange}
					density={"compact"}
					slots={{
						Pagination: CustomPagination,
						// LoadingOverlay: LinearProgress,
						LoadingOverlay: CircularProgress,
						NoRowsOverlay: CustomNoRowsOverlay,
					}}
					// loading={loadingBar} sx={{height: '635px',width: "1375px",}}/>
					loading={loadingBar}
					sx={{ width: "100%" }}
				/>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						marginTop: "15px",
						// marginBottom: "15px",
						// outline: '2px solid black'
					}}
				>
					<Button
						style={{
							backgroundColor: "#275d38",
							marginBottom: "5px",
							width: "45%",
							maxWidth: "400px",
						}}
						variant="contained"
						onClick={generateReport}
					>
						<Typography style={{ fontSize: "16px" }}>Display Reports</Typography>
					</Button>
					{!sessionStorage.getItem("access").includes("STD") && (
						<Button
							style={{
								backgroundColor: "#275d38",
								width: "45%",
								maxWidth: "400px",
							}}
							variant="contained"
							endIcon={<DownloadIcon />}
							onClick={handleClickOpen}
						>
							<Typography style={{ fontSize: "16px" }}>PDF Download</Typography>
						</Button>
					)}
					<Dialog open={openWindow} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
						<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>SPOT REPORT</DialogTitle>
						{pdfLoading ? (
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingBottom: "20px",
								}}
							>
								<CircularProgress size={80} />
							</Box>
						) : (
							<div>
								<DialogContent>
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<Typography>
											Select which elements you would like included in the PDF report:
										</Typography>
										<br></br>
										<FormGroup>
											<FormControlLabel
												control={<Checkbox checked={checked[0]} onChange={handleCheck0} />}
												label="Standard SPOT Questions"
											/>
											<FormControlLabel
												control={<Checkbox checked={checked[1]} onChange={handleCheck1} />}
												label="Supplementary Questions"
											/>
											<FormControlLabel
												control={<Checkbox checked={checked[2]} onChange={handleCheck2} />}
												label="Summary Data"
											/>
											<FormControlLabel
												control={<Checkbox checked={checked[3]} onChange={handleCheck3} />}
												label="Comments"
											/>
											<br></br>
											<FormControl variant="filled">
												<InputLabel>PDF Format</InputLabel>
												<Select value={pdfGrouping} label="PDF Format" onChange={handlePDFgrouping}>
													<MenuItem value={1}>Single PDF</MenuItem>
													<MenuItem value={2}>Separate PDF's</MenuItem>
													<MenuItem value={3}>PDF per Course</MenuItem>
													<MenuItem value={4}>PDF per Instructor</MenuItem>
												</Select>
											</FormControl>
										</FormGroup>
									</Box>
								</DialogContent>

								<DialogActions sx={{ justifyContent: "center" }}>
									<Button onClick={handleClose}>Close</Button>
									<Button onClick={PrintReport}>Generate</Button>
								</DialogActions>
							</div>
						)}
					</Dialog>
				</div>
			</div>
		</div>
	);
}
